// バイト数を計算する関数
function getCharByteLength(char) {
  // 日本語などのマルチバイト文字は2バイトとしてカウント
  // eslint-disable-next-line no-control-regex
  return char.match(/[^\x00-\x7F]/) ? 2 : 1;
}

// バイト数で文字列を短縮する関数
function truncateByByteLength(str, maxBytes) {
  // インプットがundefinedまたはnullである場合、空の文字列を返します
  if (str === undefined || str === null) {
    return "";
  }

  let bytes = 0;
  let result = '';

  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    const charByteLength = getCharByteLength(char);
    bytes += charByteLength;
    result += char;
    if (bytes > maxBytes) break;    
  }

  return bytes > maxBytes ? result + '…' : result;
}

export { getCharByteLength, truncateByByteLength };
